import _keyBy from 'lodash/keyBy';
import _map from 'lodash/map';
import {dateFormats, UTCTimezone} from 'common/src/modules/timezones/timezones.consts';
import timezonesApi from 'common/src/modules/timezones/timezones.api';
import clientsApi from 'common/src/modules/clients/clients.api';
import {CancelToken} from 'axios';
import {timezones} from '@cl/shared';

const {fetchDateTimePromise, dateTimeInfo} = timezones;

const getDateTimeInfo = async (shouldResetCache?: boolean, cancelToken?: CancelToken) => {
  if (shouldResetCache) {
    fetchDateTimePromise.current = null;
    dateTimeInfo.current = null;
  }

  if (dateTimeInfo.current) return dateTimeInfo.current;

  const [client, timezonesResponse] = await fetchDateTime(cancelToken);

  const timezoneMapper = _keyBy(timezonesResponse, (tz) => tz.id);

  dateTimeInfo.current = {
    clientDateFormat: client.defaultDateFormat || dateFormats.defaultDateFormat,
    clientTimeFormat: client.is24h
      ? dateFormats.twentyFourHoursFormat
      : dateFormats.twelveHoursFormat,

    timezonesForSelector: _map(timezonesResponse, (tz) => {
      const pnSign = tz.currentOffset >= 0 ? '+' : '';

      return {...tz, value: tz.id, label: `${tz.id} (UTC${pnSign}${tz.currentOffset})`};
    }),
    timezoneMapper,
    currentClientTimezone: timezoneMapper[client.defaultTimezone || UTCTimezone],
  };

  return dateTimeInfo.current;
};

function fetchDateTime(cancelToken?: CancelToken) {
  if (!fetchDateTimePromise.current) {
    fetchDateTimePromise.current = Promise.all([
      clientsApi.getAccountProfile({cancelToken}),
      timezonesApi.loadTimezones(cancelToken),
    ]).catch((e) => {
      fetchDateTimePromise.current = null;
      throw e;
    });
  }

  return fetchDateTimePromise.current;
}

const timezonesService = {
  getDateTimeInfo,
};

export default timezonesService;
